import { FC, ReactNode } from "react";
import { Col, Row } from "@payping/web-components";

interface Props {
  firstChild?: ReactNode;
  secondChild?: ReactNode;
}

export const FormLayout: FC<Props> = (props) => {
  const { firstChild, secondChild } = props;

  return (
    <Row justify={"start"} gutter={[16, 32]}>
      <Col xs={24} lg={18}>
        {firstChild}
      </Col>
      <Col xs={24} lg={6}>
        {secondChild}
      </Col>
    </Row>
  );
};
